import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { Menu, X } from 'lucide-react';
import { BOOKING_URL } from './constants';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Tratamientos',
    href: '#tratamientos'
  }, {
    name: 'Nosotros',
    href: '#nosotros'
  }, {
    name: 'Resultados',
    href: '#resultados'
  }, {
    name: 'Testimonios',
    href: '#testimonios'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-surface/80 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-182">
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-183">
        {/* Logo */}
        <a href="#" className="flex flex-col items-center z-50" data-id="element-184">
          <span className="font-serif text-2xl md:text-3xl text-foreground tracking-widest leading-none" data-id="element-185">
            LIBELLE
          </span>
          <span className="text-[0.65rem] uppercase tracking-[0.3em] text-gold mt-1" data-id="element-186">
            Estética
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-10" data-id="element-187">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-foreground/80 hover:text-gold transition-colors tracking-wide" data-id="element-188">
              {link.name}
            </a>)}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:block" data-id="element-189">
          <Button href={BOOKING_URL} target="_blank" rel="noopener noreferrer" variant="primary" size="sm" data-id="element-190">
            Agendar cita
          </Button>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden z-50 text-foreground" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-191">
          {isMobileMenuOpen ? <X size={28} data-id="element-192" /> : <Menu size={28} data-id="element-193" />}
        </button>

        {/* Mobile Menu Overlay */}
        <div className={`fixed inset-0 bg-surface z-40 flex flex-col items-center justify-center transition-all duration-500 ease-in-out ${isMobileMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`} data-id="element-194">
          <nav className="flex flex-col items-center gap-8" data-id="element-195">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="font-serif text-3xl text-foreground hover:text-gold transition-colors" data-id="element-196">
                {link.name}
              </a>)}
            <div className="mt-8" data-id="element-197">
              <Button href={BOOKING_URL} target="_blank" rel="noopener noreferrer" variant="primary" size="lg" onClick={() => setIsMobileMenuOpen(false)} data-id="element-198">
                Agendar valoración
              </Button>
            </div>
          </nav>
        </div>
      </div>
    </header>;
}